import { isRouteErrorResponse, useRouteError } from "react-router-dom";

export function RouteErrorBoundary() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText || "Error"}`
    : error instanceof Error
    ? error.message
    : "An unexpected error occurred.";

  return (
    <div className="flex min-h-dvh items-center justify-center p-8 text-center">
      <div className="max-w-md">
        <h1 className="m-0 text-2xl font-bold text-fg">Something went wrong</h1>
        <p className="mt-2 text-sm text-fg-mute">{message}</p>
      </div>
    </div>
  );
}
